<template>
    <router-view class="min-h-full" />
</template>

<script>
  export default {
    name: 'app',
    components: {
    },
  }
</script>